import { ButtonStyled } from './styled';

export type TButtonVariant = 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
export type TButtonSize = 'sm' | 'lg' | 'icon';
export interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  customVariant?: TButtonVariant;
  size?: TButtonSize;
  children?: React.ReactNode;
}

const Button = ({ children, ...props }: IButtonProps) => {
  return <ButtonStyled {...props}>{children}</ButtonStyled>;
};

export default Button;
